import { Component, inject, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
    decimalMaskNumberConfigOverride,
    integerMaskNumberConfigOverride,
    LogicStepOption,
    LogicStepParameter,
    LogicStepParameterProperty,
    LogicStepParameterType,
} from '@wdx/shared/utils';
import { map, Observable, tap } from 'rxjs';
import { ExtendedPrimitiveKinds } from '../../../utils/logic-step-parameter-kinds';
import { IWrappedWorkflowFormComponentProvider } from '../../../interfaces';
import { WorkflowParameterOptionsService } from '../../../services';

@Component({
    selector: 'clmi-workflow-designer-parameter-input',
    templateUrl: './parameter-input.component.html',
    standalone: false,
})
export class WorkflowDesignerParameterInputComponent implements OnInit {
    private readonly parameterOptionsService = inject(
        WorkflowParameterOptionsService,
    );

    @Input() parameter!:
        | LogicStepParameter
        | (LogicStepParameterProperty & {
              properties?: Array<LogicStepParameterProperty> | null;
          });
    @Input() formGroup?: FormGroup;
    @Input() componentProvider?: IWrappedWorkflowFormComponentProvider;

    readonly integerMaskNumberConfigOverride = integerMaskNumberConfigOverride;
    readonly decimalMaskNumberConfigOverride = decimalMaskNumberConfigOverride;
    readonly KnownKinds = ExtendedPrimitiveKinds;
    readonly LogicStepParameterType = LogicStepParameterType;

    public options$: Observable<LogicStepOption[]>;
    public loadingOptions = false;

    ngOnInit(): void {
        this.initialiseOptions();
    }

    private initialiseOptions() {
        this.loadingOptions = true;

        const currentValue = this.formGroup.get(this.parameter.code)?.value;

        this.options$ = this.parameterOptionsService
            .getOptions(this.parameter)
            .pipe(
                map((options) => {
                    if (
                        typeof currentValue === 'string' &&
                        currentValue.startsWith('regarding.')
                    ) {
                        return options.map((o) => ({
                            ...o,
                            value: `regarding.${o.value}`,
                        }));
                    }

                    return options;
                }),
                tap(() => (this.loadingOptions = false)),
            );
    }
}
